import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";

const TABLE_ROWS = ["r1", "r2", "r3", "r4", "r5", "r6", "r7", "r8"];

const LiveDashboardSkeleton = () => (
	<Container maxWidth="lg" sx={{ pt: 2 }}>
		<Stack
			direction="row"
			spacing={2}
			sx={{
				alignItems: "center",
				mb: 2,
			}}
		>
			<Skeleton
				variant="rectangular"
				width={160}
				height={40}
				sx={{ borderRadius: 1 }}
			/>
			<Skeleton variant="text" width={120} height={32} />
			<Skeleton variant="circular" width={12} height={12} />
			<Skeleton variant="text" width={50} height={20} />
		</Stack>
		<Paper sx={{ p: 2 }}>
			<Skeleton
				variant="rectangular"
				width={200}
				height={36}
				sx={{ mb: 2, borderRadius: 1 }}
			/>
			<Stack spacing={1}>
				{TABLE_ROWS.map((key) => (
					<Stack
						key={key}
						direction="row"
						spacing={2}
						sx={{
							alignItems: "center",
							py: 1,
						}}
					>
						<Skeleton variant="text" width={140} height={20} sx={{ flex: 1 }} />
						<Skeleton variant="text" width={60} height={20} />
						<Skeleton variant="text" width={60} height={20} />
						<Skeleton variant="text" width={60} height={20} />
						<Skeleton variant="text" width={80} height={20} />
					</Stack>
				))}
			</Stack>
		</Paper>
	</Container>
);

export default LiveDashboardSkeleton;
